import sitePointsApi from "@/api/points";
import { useToastNotificationStore } from "@/experiences/toast-notifications/store/toast-notifications";
import { defineStore } from "pinia";
import { ref } from "vue";
export const useSitePointsStore = defineStore("sitePointsStore", () => {
    const notifier = useToastNotificationStore();
    const config = ref();
    const defaultValues = ref();
    // Fetches available templates and recipients
    const load = async () => {
        try {
            const response = await sitePointsApi.getSitePointsConfig();
            config.value = response.sitePointConfig;
            defaultValues.value = response.pointDefaultValues;
        }
        catch (e) {
            console.error(e);
            notifier.addErrorNotice("Error loading points configuration");
        }
    };
    const save = async () => {
        try {
            if (config.value) {
                config.value = await sitePointsApi.updateSitePointsConfig(config.value);
            }
        }
        catch (e) {
            console.error(e);
            notifier.addErrorNotice("Error saving points configuration");
        }
    };
    return {
        config,
        defaultValues,
        load,
        save
    };
});
export const usePointLogsStore = defineStore("sitePointLogStore", () => {
    const getFilterDefault = () => {
        return {
            fromDate: undefined,
            toDate: undefined,
            userIds: [],
            segmentIds: [],
            minPoints: undefined,
            maxPoints: undefined,
            actionTypes: [],
            sortedAsc: false
        };
    };
    const filters = ref(getFilterDefault());
    const stats = ref();
    const logs = ref([]);
    const startRecord = ref(0);
    const recordsPerPage = ref(50);
    const totalRecords = ref(0);
    const pageCount = ref(0);
    const myLogs = ref(false);
    const focusUserId = ref(null);
    const load = async () => {
        try {
            if (focusUserId.value) {
                filters.value.userIds = [focusUserId.value];
            }
            const response = await sitePointsApi.getSitePointLogs({
                filter: filters.value,
                startRecord: startRecord.value,
                recordCount: recordsPerPage.value
            }, myLogs.value);
            logs.value = response.actionLogs;
            stats.value = response.actionLogStats;
            totalRecords.value = response.actionLogStats.totalActions;
            pageCount.value = Math.ceil(totalRecords.value / recordsPerPage.value);
        }
        catch (e) {
            console.error(e);
        }
    };
    const resetFilters = () => {
        filters.value = getFilterDefault();
    };
    return {
        filters,
        focusUserId,
        resetFilters,
        stats,
        logs,
        startRecord,
        recordsPerPage,
        totalRecords,
        pageCount,
        myLogs,
        load
    };
});
